module.exports = __webpack_public_path__ + "media/images/black-logo-13ac09305a1f65e0fd83f944dff73ad7.jpg";